export namespace SystemUserReportsConstants {
  export const Table = 'Table';
  export enum COLUMN_WIDTH {
    'races.name' = '200px',
  }
}
